import React, {Component} from 'react'
import SplitIOTreatment from "../components/splitio/splitioTreatment";
// import { getSplitIOTreatments } from '../modules/splitIO';

let useCDNGameContentSource = false;
const backendUrl = process.env.REACT_APP_API_SERVER ? process.env.REACT_APP_API_SERVER : "//localhost:5001";
const playContentUrl = process.env.REACT_APP_PLAY_CONTENT_URL ? process.env.REACT_APP_PLAY_CONTENT_URL : "//localhost:8080";
const Constants = {
    BACKEND_URL: backendUrl,
    PLAY_CONTENT_URL: playContentUrl,
    // eslint-disable-next-line
    getPlayContentUrl: ()=>{return useCDNGameContentSource? playContentUrl: backendUrl;},
    GAME_SERVER_URL:  process.env.REACT_APP_GAME_SERVER_URL ? process.env.REACT_APP_GAME_SERVER_URL : "//localhost:8081",
    SUPER_ROLE: "timocco admin",
    REGIONAL_ADMIN_ROLE: "regional admin",
    ADMIN_ROLE: "organization admin",
    THERAPIST_ROLE: "therapist",
    ADMIN_ROLE_LEVEL: 0,
    PLAYER_ROLE_LEVEL: 25,
    CARE_PARTNER_ROLE_LEVEL: 15,
    ORGANIZATION_ADMIN_ROLE_LEVEL: 5,
    REGIONAL_ADMIN_ROLE_LEVEL: 4,
    BUSINESS_GROUP_ADMIN_ROLE_LEVEL: 3,
    THERAPIST_ROLE_LEVEL: 10,
    HTTP_OK: 200,
    HTTP_UNAUTHORIZED: 401,
    RESULTS_PAGE_SIZE:3
};

const featureName = "DC-14-CDN-by-businessgroup";

// This component exists to check feature toggle and shift content of PLAY_CONTENT_URL 
export class ConstantsModifier extends Component{
    renderToggle(toggleOn){
        useCDNGameContentSource = toggleOn;
        return (<span data-test-component="ConstantsModifierOn"></span>)
    }
    render(){
        return(
            <SplitIOTreatment featureName={featureName} treatmentValue="on" trafficType="business-group">
                    {(treatment)=>{
                        if (treatment === "on") {
                            return this.renderToggle(true);
                        }
                        return null;
                        
                    }}
            </SplitIOTreatment>
        )
    }
}

export default Constants;



// WEBPACK FOOTER //
// ./src/constants/constants.js